<template>
  <b-modal
    title="NOVA CATEGORIA"
    no-close-on-backdrop
    hide-footer
    id="new_category"
    @show="evOnShow"
    @shown="evOnShown"
  >
    <b-overlay :show="loading" opacity="0.99">
      <b-form method="post" @submit.prevent="evOnSubmit">
        <b-row>
          <b-col>
            <label-required-field label="Nome" />
            <b-input type="text" v-model="name" ref="autofocus" />
          </b-col>
        </b-row>
        <warning-required-fields />
        <errors-messages :errors="errors" />
        <b-row align-h="end">
          <b-col cols="auto">
            <v-btn type="submit" class="btn-add">
              <i class="fas fa-plus mr-2 text-twenty"></i>
              ADICIONAR
            </v-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import api from "../../services/api";
import toast from "../../lib/ToastNotification";

export default {
  name: "NewCategory",
  components: {
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
  },
  props: {
    form_id: [String, Number],
  },
  data() {
    return {
      errors: [],
      loading: false,
      name: "",
    };
  },
  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.name = "";
    },
    async evOnShown() {
      this.$refs.autofocus.focus();
    },
    async evOnSubmit() {
      try {
        this.loading = true;

        let data = {
          form_id: this.form_id,
          name: this.name,
        };
        let response = await api.post(
          "/rest-home/semiology/form/category",
          data
        );
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$emit("created");
          toast(message, "success");
          this.$bvModal.hide("new_category");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
